import React, { useState } from "react";

import { ConsoleLayout } from "./consoleParts";
import { SetsCard } from "./SetsCard";
import { UploadSheetCard } from "./UploadSheetCard";

/**
 * The staff page for the warm-up bank: check and import the warm-up sheet,
 * read every set with its questions, answers and hints, and turn sets on or
 * off. Built from the Feature Flags console's parts.
 */
export const WarmUpSetsAdminConsole = () => {
  const [listVersion, setListVersion] = useState(0);

  return (
    <ConsoleLayout className="admin-warm-up-sets-console">
      <UploadSheetCard onImported={() => setListVersion((version) => version + 1)} />
      <SetsCard listVersion={listVersion} />
    </ConsoleLayout>
  );
};
